import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { Modal } from 'bootstrap';

import { TourismMapService, Transport, Action } from '../tourism-map.service';

@Component({
	selector: 'app-tourism-map-people',
	templateUrl: './tourism-map-people.component.html',
	styleUrls: ['./tourism-map-people.component.css'],
})
export class TourismMapPeopleComponent implements OnChanges {
	@Input() city;
	@Output() cityChange = new EventEmitter();
	@Input() vehicle;
	@Output() vehicleChange = new EventEmitter();
	@Input() editable = false;
	transports: Array<Transport> = [];
	actions: Array<Action> = [];

	@Output() closed = new EventEmitter();

	vehicleTable = [];
	vehicleTableChange = new EventEmitter();

	constructor(private readonly map: TourismMapService) {
		map.transportsChange.subscribe((transports) => {
			this.transports = transports;
		});
		map.actionsChange.subscribe((actions) => {
			this.actions = actions;
		});
		map.vehicleTableChange.subscribe((vehicleTable) => {
			this.vehicleTable = vehicleTable;
		});
	}

	ngOnChanges(): void {
		if (!this.vehicle || !this.city) {
			return;
		}
		this.map.vehicleTableRefresh(this.vehicle);
		const myModal = document.getElementById('tourismMapPeopleModal');
		new Modal(myModal).show();
		myModal.addEventListener('hidden.bs.modal', (event) => {
			this.closed.emit(true);
		});
	}

	driveThru() {
		this.map.driveThru(this.city, this.vehicle);
		this.close();
	}

	getPeople(reservation) {
		this.map.getPeople(reservation, this.city, this.vehicle);
	}

	getAll() {
		for (let i = this.city.reservations.length - 1; i >= 0; i--) {
			this.getPeople(this.city.reservations[i]);
		}
		this.close();
	}

	putPeople(item) {
		this.map.putPeople(item.action, this.city, this.vehicle);
	}

	putAll() {
		this.vehicleTable.forEach((pos) => {
			if (!pos.action) {
				return;
			}
			this.putPeople(pos);
		});
		this.close();
	}

	close() {
		const modal = Modal.getInstance(document.getElementById('tourismMapPeopleModal'));
		if (!modal) {
			return;
		}
		modal.hide();
		this.closed.emit(true);
	}
}
